import { combineReducers } from 'redux';

import modal from './modal';
import profile from './profiles';
import avatars from './avatars';
import form from './form';

const profilesReducer = combineReducers({
  modal,
  profile,
  avatars,
  form,
});

export default profilesReducer;
